<template>
  <div class="loading" v-if="mostrar">
    <div class="sk-spinner sk-spinner-three-bounce">
      <div class="sk-bounce1" :style="[cor]"></div>
      <div class="sk-bounce2" :style="[cor]"></div>
      <div class="sk-bounce3" :style="[cor]"></div>
    </div>
    <div>{{ message }}</div>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      color: {
        type: String,
        default: '#c2c5c7'
      },
      message: {
        type: String,
        default: 'Carregando'
      }
    },
    data () {
      return {
        cor: {
          backgroundColor: this.color
        }
      }
    },
    computed: {
      mostrar () {
        return this.loading
      }
    }
  }
</script>

<style scoped>
  .loading {
    text-align: center;
    color: #c2c5c7;
  }

  .sk-spinner-three-bounce.sk-spinner {
    margin: 5px auto;
    width: 70px;
    text-align: center;
  }

  .sk-spinner-three-bounce div {
    width: 18px;
    height: 18px;
    // background-color: $spin-color;
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-threeBounceDelay 1.4s infinite ease-in-out;
    animation: sk-threeBounceDelay 1.4s infinite ease-in-out;
    /* Prevent first frame from flickering when animation starts */
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .sk-spinner-three-bounce .sk-bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .sk-spinner-three-bounce .sk-bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-threeBounceDelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }

    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes sk-threeBounceDelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }

    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PortalLoading.vue